import { render, staticRenderFns } from "./AdminContactView.vue?vue&type=template&id=4428ef13&scoped=true&"
import script from "./AdminContactView.vue?vue&type=script&lang=js&"
export * from "./AdminContactView.vue?vue&type=script&lang=js&"
import style0 from "./AdminContactView.vue?vue&type=style&index=0&id=4428ef13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428ef13",
  null
  
)

export default component.exports